import { Box, Typography } from '@mui/material';
import { Order, OrderItem } from '../../../order.types';
import OrderSummaryItem from './OrderSummaryItem';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../../../../constants/language';
import { useMemo } from 'react';
import { useAuthContext } from '../../../../../context/authContext';

const OrderSummary: React.FC<{ item: Order; type: string }> = ({ item, type }) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const foods = useMemo(() => (type === 'promotion' ? item?.promotion_foods ?? [] : item?.foods ?? []), [item?.foods, item?.promotion_foods, type]);

  const totalQuantity = useMemo(() => {
    return foods.reduce((sum, food) => {
      const actualQuantity = food.item_deleted_quantity !== undefined ? food.item_quantity - food.item_deleted_quantity : food.item_quantity;

      return sum + (actualQuantity || 0);
    }, 0);
  }, [foods]);

  const myRestaurantIds = useMemo(
    () => item.multi_orders?.filter((multiOrder) => multiOrder.rider_id === user?.uid).map((multiOrder) => multiOrder.restaurant_id) ?? [],
    [item.multi_orders, user?.uid]
  );

  const isItemAssigned = (orderItem: OrderItem) => {
    if (!item.multi_orders?.length) {
      return !item?.rider_id || item?.rider_id === user?.uid;
    }

    if (!myRestaurantIds.length || !orderItem.restaurantId) {
      return true;
    }

    return myRestaurantIds.includes(orderItem.restaurantId);
  };

  return (
    <Box bgcolor="white">
      <Box display="flex" gap="10px" alignItems="center" padding="12px">
        <Typography fontSize="14px" lineHeight="20px" color="#667085" fontWeight="500">
          {t(LANG_TEXT.ORDER_SUMMARY)}
        </Typography>
        <Box borderRight="1px solid #EAECF0" height="14px" />
        <Typography fontSize="14px" lineHeight="20px" color="#98A2B3" fontWeight="500">
          {totalQuantity} {t(LANG_TEXT.ORDER_ITEMS)}
        </Typography>
      </Box>
      <Box>
        {foods.map((_item, index) => (
          <OrderSummaryItem key={`${_item.item_food_id}-${index}`} orderItem={_item} isAssigned={isItemAssigned(_item)} />
        ))}
      </Box>
    </Box>
  );
};

export default OrderSummary;
